export enum MenuItemRequirement {
  None = 0,
  ElectricOutlet = 1,
  Ventilation = 2,
  Indoors = 4,
  Outdoors = 8,
}
